<script>
  import { IsNullOrEmpty, IsDevSim } from '@/modules/helper/index'
    import { mapGetters } from 'vuex'
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      decimalplaces: {
        type: Number        
      },
      defaultNumber: {
        type: String        
      },
      required: {
        type: Boolean,
        default: false
      },
      fieldType: {
        type: String,
        default: 'number' 
      },
      currencytype: {
        type: String
      },
      value: {
        type: String
      },
      showcurrency: {
        type: Boolean
      },
      errorMessage: {
        type: String,
        default: '' // default
      }
    },
    data: function() {
      return {
        isInputActive:false
      }
    },
    computed: {
      ...mapGetters([
        'resource',
        'language'
      ]),
      // setdefaultNumber: {
      //   get() {
      //     return this.formatevalue(this.defaultNumber)        
      //   },
      //   set(number) {
      //     number = this.formatevalue(number)
      //     this.$emit('propChange', { value : number })
      //   }
      // },
      defaultValue: {
          get() {
              if (this.isInputActive) {
                  if (!this.value || this.value === '' || this.value === '0') {
                     return ''    
                  }
                  $event.target.value = value
                  return this.value
              } else {
                  let newValue = this.value // && parseFloat(this.value.replace(/[^\d\.]/g, ""))
                  if (IsDevSim() && this.defaultNumber) {
                    return this.defaultNumber
                  }
                  if (newValue === '0' && this.defaultNumber === '0') {
                    return 0
                  }
                  if (!newValue || newValue === '' || newValue === '0' || newValue === 0) {
                    return ''
                  }
                  return this.value
              }
          },
          set(modifiedValue) {
              if (modifiedValue ==='') {
                this.$emit('propChange', { value: '' })
                return
              }
              this.$emit('propChange', { value: modifiedValue })
          }
      },      
      IsNullOrEmptyErrorMessage() {
        if (this.required && !IsNullOrEmpty(this.value)) {
          return true
        }
      }
    },    
    methods: {
      checkvalue($event) {        
        if (value === '') {
          $event.target.value = ''
          return ''
        }
        let value = this.formatevalue($event.target.value, $event) // $event.target.value
        // $event.target.value = value
        return value
      },
      formatevalue(value, $event) {
        if (value === '') {
           return ''
        }
        if(this.language === 'de') {
          value = value.replace(/\./g,'')
          value = value.replace(",", ".")
          if (isNaN(value)) {
            $event.target.value = ''
            return ''
          }
          let newValuede = parseFloat(parseFloat(value).toFixed(this.decimalplaces)).toLocaleString('de')
          if(value.charAt(value.length-1) !== '.' && $event) {
            $event.target.value = newValuede
          } 
          return newValuede
        }
        value = value.replace(/\,/g,'')
        if (isNaN(value) && $event) {
          if(value === '.') {
            $event.target.value = '.'
            return '.'
          }
          $event.target.value = ''
          return ''
        }
        if (isNaN(value)) {
          $event.target.value = ''
          return ''
        }
        let newValue = parseFloat(parseFloat(value).toFixed(this.decimalplaces)).toLocaleString(this.language)
        if(value.charAt(value.length-1) !== '.' && $event) {
            $event.target.value = newValue
          } 
        if (this.showcurrency) {
          if (this.currencytype === '$') {
          return this.currencytype + ' ' + newValue
          } else {
          return newValue + ' ' +  this.currencytype
          }
        } else {
          return newValue
        }

      }
    },
    created () {
       this.$emit('propChange', { value: this.defaultNumber })
    }
  }
</script>
<template>
  <f7-list class="inputs-list">
    <f7-list-item class="input-wrapper">
      <f7-label class="label-color">{{label}}</f7-label>
       <!--<f7-input type="text" class="input-value-color"  @blur="isInputActive = false" 
       @focus="isInputActive = true" :value="setdefaultNumber" 
       @input="defaultValue = checkvalue($event)" :maxlength="30" /> -->
       <f7-input type="text" class="input-value-color" :value="defaultValue" 
       @input="defaultValue = checkvalue($event)" :maxlength="30" />
      <div v-if="!IsNullOrEmptyErrorMessage" class="color-red">{{errorMessage}}</div>
    </f7-list-item>

  </f7-list>
</template>
<style scoped>
  .list {
    margin: 15px 0;
  }
  .item-label {
    line-height: 15px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/NumberInput.vue